import { graphql, requestSubscription } from 'react-relay';
import environment from '../../environment';

const subscription = graphql`
    subscription generalLeaderboardSubscription($event_id: ID!) {
        updateGeneralLeaderboard(event_id: $event_id){
            event_id
        }
    }
`;

function generalLeaderboardSubscription(variables, onNext) {    
    const disposable = requestSubscription(environment, {
        subscription: subscription,
        variables: variables,
        onNext: (response) => {
            onNext(response);
        },
        onError: (error) => {
            console.error('Subscription error:', error);
        },
        onCompleted: () => {
            console.log('Subscription completed');
        }
    });

    return () => {
        disposable.dispose();
    };
}

export default generalLeaderboardSubscription;